module.exports = __webpack_public_path__ + "img/1.afc53956.jpg";